import { Template } from './Template';

export const modal = (
    title: string,
    content?: HTMLElement[] | HTMLElement | string,
    icons?: HTMLElement[] | HTMLElement | string,
): HTMLElement => Template.createElement(
    'div', { class: 'juba-modal' }, [
        Template.createElement(
            'div', { class: 'juba-modal__header' }, [
                Template.createElement(
                    'div', { class: 'juba-modal__title' }, title,
                ),
                Template.createElement(
                    'div', { class: 'juba-modal__close' }, Template.createElement(
                        'span', { class: 'material-icons' }, 'close',
                    ),
                ),
            ],
        ),
        Template.createElement(
            'div', { class: 'juba-modal__content-wrapper' }, [
                Template.createElement(
                    'div', { class: 'juba-modal__icons' }, icons,
                ),
                Template.createElement(
                    'div', { class: ['juba-modal__content', 'soft-scroll'] }, content,
                ),
            ],
        ),
    ],
);
